import { Component, OnDestroy, OnInit } from '@angular/core';

import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FillStudentComponent } from 'src/app/components/to-back/fill-student/fill-student.component';

@Component({
  selector: 'app-homethirteen-main-banner',
  templateUrl: './homethirteen-main-banner.component.html',
  styleUrls: ['./homethirteen-main-banner.component.scss'],
  providers: [DialogService, MessageService]
})
export class HomethirteenMainBannerComponent implements OnInit, OnDestroy {
  ref: DynamicDialogRef;

  constructor(
    private dialogService: DialogService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    
  }

  show(): void {
    this.ref = this.dialogService.open(FillStudentComponent, {
      width: '100%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true
    });

    this.ref.onClose.subscribe((product: any) => {
      if (product) {
          this.messageService.add({ severity: 'info', summary: 'Product Selected', detail: product.name });
      }
    });

    this.ref.onMaximize.subscribe((value) => {
      this.messageService.add({ severity: 'info', summary: 'Maximized', detail: `maximized: ${value.maximized}` });
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }

}
